// extracted by mini-css-extract-plugin
export default {"wipTable":"WipTable_wipTable__bXAFB","toolbar":"WipTable_toolbar__YVedL","field":"WipTable_field__hx3JP","loading":"WipTable_loading__WwR1o","empty":"WipTable_empty__dQYn8"};